export const appConfig = {
    baseUrl: import.meta.env.VITE_BASE_URL ?? '',
    isHybridApp: import.meta.env.MODE === 'app' || import.meta.env.MODE === 'app-prod',
    defaultApiRequestHeaders:
        import.meta.env.MODE === 'app'
            ? {
                  'ngrok-skip-browser-warning': 'true',
              }
            : {},
};
